import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";

const sections = [
  {
    num: "01",
    title: "Introduction",
    body: "This Copyright Policy outlines the procedures and guidelines for addressing copyright-related matters on the Snows ProAm mobile application (the \"App\"). Snows ProAm Inc. (\"we,\" \"us,\" or \"our\") respects the intellectual property rights of others and expects our users to do the same.",
  },
  {
    num: "02",
    title: "Copyright Ownership",
    body: "All content and materials available on the App, including but not limited to text, images, graphics, audio, videos, software, and any other intellectual property, are protected by copyright laws and are the property of Snows ProAm Inc. or its content suppliers.",
  },
  {
    num: "03",
    title: "Reporting Copyright Infringements",
    body: "We take copyright infringement seriously and strive to respect the intellectual property rights of others. If you believe that your copyrighted work has been used or displayed on the App in a way that constitutes copyright infringement, please provide us with the following information:",
    list: [
      "A description of the copyrighted work you believe has been infringed.",
      "A description of the content you believe to be infringing and its location on the App.",
      "Your contact information, including your name, address, telephone number, and email address.",
      "A statement by you that you have a good-faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law.",
      "A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.",
    ],
    note: "Please send this information to info@snowsproam.com so that we may forward it to our Designated Copyright Agent.",
  },
  {
    num: "04",
    title: "Action on Copyright Infringement Reports",
    body: "Upon receiving a proper notice of copyright infringement, we will take appropriate actions, which may include:",
    list: [
      "Removing or disabling access to the allegedly infringing content.",
      "Notifying the user who posted the content about the complaint.",
      "Termination of user accounts or access for repeat infringers.",
    ],
  },
  {
    num: "05",
    title: "Counter-Notification",
    body: "If a user believes their content was removed or disabled as a result of an incorrect copyright infringement report, they may send a counter-notification to our Designated Copyright Agent. The counter-notification should include:",
    list: [
      "Identification of the content that was removed or disabled and its location.",
      "User's contact information, including their name, address, telephone number, and email address.",
      "A statement under penalty of perjury that the user has a good-faith belief that the content was removed or disabled as a result of a mistake or misidentification.",
      "A statement that the user consents to the jurisdiction of the Irish courts and that they will accept service of process from the person who provided the original copyright infringement report.",
    ],
    note: "Please send the counter-notification to our Designated Copyright Agent at info@snowsproam.com.",
  },
  {
    num: "06",
    title: "Changes to this Copyright Policy",
    body: "We may update this Copyright Policy to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify users of any material changes by posting the updated Copyright Policy on our website or within the App.",
  },
];

export default function CopyrightPolicy() {
  return <LegalDocumentPage title="Copyright Policy" description="Our copyright guidelines and how to report content you believe infringes your rights." effective="January 2024" sections={sections} />;
}
